import { render, staticRenderFns } from "./PainelAjuda.vue?vue&type=template&id=54c94bdb&scoped=true"
import script from "./PainelAjuda.vue?vue&type=script&lang=js"
export * from "./PainelAjuda.vue?vue&type=script&lang=js"
import style0 from "./PainelAjuda.vue?vue&type=style&index=0&id=54c94bdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c94bdb",
  null
  
)

export default component.exports